import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"

//components
import * as manageUnassignedAction from "../../store/dW5hc3NpZ25lZEVj/actions"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as manageEcAction from "../../store/TWFuYWdlRWM/actions"
import api from "helpers/Api"

const ManageEc = (props) => {
  const title = "Manage EC"
  const { dispatch, searchBarStyle } = props

  useEffect(() => {
    dispatch(manageEcAction.loadRecordsMetaData())
    dispatch(permissionAction.loadEmployee())
    dispatch(
      manageEcAction.loadManageEcList({
        isManageEC: true,
        page: 1,//25
        limit: 25,
      })
    )
    function handleContextMenu(e) {
      e.preventDefault() // prevents the default right-click menu from appearing
    }
    // add the event listener to the component's root element
    const rootElement = document.getElementById("my-component")
    rootElement.addEventListener("contextmenu", handleContextMenu)
    // remove the event listener when the component is unmounted

    return () => {
      rootElement.removeEventListener("contextmenu", handleContextMenu)
    }
  }, [])
  const specificDispatch = useDispatch()

  const manageEcUpdate = useSelector((state) => state.manageEc)

  const { manageEcMetaData = {}, manageEc_details = [] } = manageEcUpdate

  const employeeUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )

  const { employee_list = [] } = employeeUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const [downloadLoading, setDownloadLoading] = useState(false)
  //manage Ec initial state
  const [manageEcData, setManageEcData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  //filter table change

  //handle change
  const handleChange = async (e) => {
    setManageEcData({ ...manageEcData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [venueName, setVenueName] = useState([])
  const [isPremium, setIsPremium] = useState("")
  const [salesAgent, setSalesAgent] = useState([])

  const statusList = [
    {
      label: "Is Premium",
      value: true,
    },
  ]

  console.log(isPremium, "isPremium")
  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    console.log(e, "value")
    console.log("chooseData handle isChecked ", isChecked)
    if (isChecked) {
      setIsPremium(value)
      // setAuditChecked(true)
    } else {
      setIsPremium(false)
    }
    console.log("choose value", value)
  }
  //alter checkbox
  const alterList = [
    {
      label: "Is Alter",
      value: true,
    },
  ]

  const [isAlter, setIsAlter] = useState("")
  const handleAlterChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setIsAlter(value)
    } else {
      setIsAlter(false)
    }
  }
  //reset functionalities
  const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSalesAgent([])
    setIsPremium(false)
    setVenueName([])
    setIsAlter(false)
    setManageEcData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      manageEcAction.loadManageEcList({
        isManageEC: true,
        page: pageChange ? pageCount : 1,
        limit: 25,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //clearance modal
  const [clearanceModal, setClearanceModal] = useState(false)
  const [clearanceHistoryModal, setClearanceHistoryModal] = useState(false)
  const [clearanceHistoryDetails, setClearanceHistoryDetails] = useState("")

  const handleClearanceHistory = () => setClearanceHistoryModal(false)
  // assign modal dropdown list
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(false)
  const [companyDetails, setCompanyDetails] = useState([])
  const [branchDetails, setBranchDetails] = useState([])
  const [salesAgentList, setSalesAgentList] = useState([])
  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const branchOptions =
    !isEmpty(manageEcMetaData) &&
    manageEcMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })
  console.log(employee_list, "employeeee")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const ecagentOptions = createOptions(employeeList)
  const agentOptions = createOptions(employeeList)

  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  //Searchvalue
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const [pageCount, setPageCount] = useState("")
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
      isManageEC: true,
      page: pageChange ? pageCount : 1,
      limit: 25,
    }
  const eventValue =
    !isEmpty(events) && events.length > 0 ? events.map((val) => val.value) : []
  //apply filter submit
  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent =
      !isEmpty(eventValue) && eventValue.length > 0 ? eventValue : ""
    //  var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchVenue = venueName && venueName ? venueName.value : ""

    var searchFromDate =
      manageEcData && manageEcData.fromDate
        ? moment(manageEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      manageEcData && manageEcData.toDate
        ? moment(manageEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      manageEcData && manageEcData.leadNo ? manageEcData.leadNo : ""
    var searchPremium = isPremium == true ? true : false
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.isManageEC = true
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 25
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchVenue) {
      searchvalue.venueName = searchVenue
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    setSearchValueList(searchvalue)
    console.log(searchvalue, "searchvalue")
    dispatch(manageEcAction.loadManageEcList(searchvalue))
    setBtnLoader(true)
    setDownloadLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setDownloadLoading(false)
    }, 2000)
  }

  //Assign details
  const [assignData, setAssignData] = useState({
    company: "",
    branch: "",
  })
  const [assignDetails, setAssignDetails] = useState("")

  const [leadNo, setLeadNo] = useState("")
  console.log(salesAgentList, "salesAgentList")
  //Assign modal data's
  const editAssignDetails = (assignDetails) => {
    console.log(assignDetails, "assignDetails")
    setCompanyDetails({
      label: assignDetails.companyName,
      value: assignDetails.companyId,
    })
    setBranchDetails({
      label: assignDetails.branchName,
      value: assignDetails.branchId,
    })
    // set
    setSalesAgentList({
      label: assignDetails.assignedEcName,
      value: assignDetails.assignedEcId,
    })
    setAssignData({
      ...assignData,
      company: [
        { label: assignDetails.companyName, value: assignDetails.companyId },
      ],
      branch: [
        {
          label: assignDetails.branchName,
          value: assignDetails.branchId,
        },
      ],
    })
    setLeadNo(assignDetails.leadNoData)
  }

  //lead id
  const [leadId, setLeadId] = useState("")
  const [unassignedData, setUnassignedData] = useState("")
  const [unassignedModal, setUnassignedModal] = useState(false)
  const handleUnassignedModal = () => setUnassignedModal(true)
  //data table for manageEc

  const colorCode = !isEmpty(manageEcMetaData)
    ? manageEcMetaData.processStatusOptions.filter(
      (status) => status.processStatusId === "PS21"
    )
    : []

  console.log(colorCode, "colorCode")
  console.log(manageEcMetaData, "manageEcMetaData")

  let slNo = 0
  const manageEcDataTable =
    !isEmpty(manageEc_details) && manageEc_details.data.length > 0
      ? manageEc_details.data.map((manageEcdata, index) => {
        slNo = slNo + 1

        const leadDate = manageEcdata.leadDate
          ? moment(manageEcdata.leadDate)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(`${dateFormate} hh:mm A`)
          : []

        const eventCount =
          !isEmpty(manageEcdata) && manageEcdata.events.length > 0
            ? manageEcdata.events.length
            : 0
        const colorCode =
          manageEcdata &&
            !isEmpty(manageEcdata.ecProcessStatus) &&
            !isEmpty(manageEcMetaData) &&
            manageEcMetaData.processStatusOptions &&
            manageEcMetaData.processStatusOptions.length > 0
            ? manageEcMetaData.processStatusOptions.find(
              (_) => _.processStatusId === manageEcdata.ecProcessStatus
            ) &&
            manageEcMetaData.processStatusOptions.find(
              (_) => _.processStatusId === manageEcdata.ecProcessStatus
            )
            : []
        return {
          _id: manageEcdata._id,
          sNo: slNo,
          colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",
          statusName: !isEmpty(colorCode) ? colorCode.label : "",
          leadNo: manageEcdata.leadNo,
          branchId: manageEcdata.branchId,
          routeData: manageEcdata,
          leadNoData: manageEcdata.leadNo,
          branchName: manageEcdata.branchName,
          clientName: !isEmpty(manageEcdata.clientDetails)
            ? manageEcdata.clientDetails.firstName +
            " " +
            manageEcdata.clientDetails.lastName
            : "",
          brideName: manageEcdata.brideName,
          groomName: manageEcdata.groomName,
          companyId: manageEcdata.companyId,
          companyName: manageEcdata.companyName,
          leadServiceName: manageEcdata.leadServiceName,
          leadSourceName: manageEcdata.leadSourceName,
          leadType: manageEcdata.leadType,
          salesUrge: manageEcdata.salesUrge,
          overallStatus: !isEmpty(manageEcdata.overAllStatus)
            ? manageEcdata.overAllStatus
            : "--",
          paymentStatus: !isEmpty(manageEcdata.paymentStatus)
            ? manageEcdata.paymentStatus
            : "",
          allowOrderData: manageEcdata.isAllowOrder,
          allowOrder: manageEcdata.isAllowOrder === true ? "YES" : "NO",
          eventDetails: manageEcdata.events,
          clientCode: !isEmpty(manageEcdata.clientDetails)
            ? manageEcdata.clientDetails.clientNo
            : "",
          events: eventCount,
          ecAssign: isEmpty(manageEcdata.ecProcessStatus)
            ? "Unassigned"
            : "Assigned",
          assignedEcName: !isEmpty(manageEcdata.leadECAssign)
            ? manageEcdata.leadECAssign.assignedToName
            : "",
          assignedEcId: !isEmpty(manageEcdata.leadECAssign)
            ? manageEcdata.leadECAssign.assignedTo
            : "",
          salesAgentName: !isEmpty(manageEcdata.leadAssign)
            ? manageEcdata.leadAssign.assignedToName
            : "--",
          leadClearanceType: !isEmpty(manageEcdata.leadClearance)
            ? manageEcdata.leadClearance.type
            : "--",
          leadClearanceStatusId: !isEmpty(manageEcdata.ecClearanceStatus)
            ? manageEcdata.ecClearanceStatus
            : "",
          leadClearanceName: !isEmpty(manageEcdata.ecClearanceStatusName)
            ? manageEcdata.ecClearanceStatusName
            : "",
          leadDate: leadDate,
          ecProcessStatus: manageEcdata.ecProcessStatus,
          ecProcessStatusName: manageEcdata.ecProcessStatusName,
          clearanceReport:
            manageEcdata.ecProcessStatus !== "PS2"
              ? manageEcdata.ecProcessStatusName
              : "--",
          clearanceStatus: (
            <Badge
              color={
                manageEcdata.ecProcessStatus === "PS21" ? "success" : "danger"
              }
              style={{ padding: "6px" }}
            >
              Clearance
            </Badge>
          ),
          leadStatus: (
            <Badge
              color={
                manageEcdata.leadAssign.leadStatus === "PS2"
                  ? "success"
                  : "danger"
              }
              style={{ padding: "6px" }}
            >
              {" "}
              {!isEmpty(manageEcdata) &&
                manageEcdata.leadAssign.leadStatus === "PS2"
                ? "Assigned"
                : "Unassigned"}
            </Badge>
          ),
          ecLeadStatus: manageEcdata.ecProcessStatusName,
          processStatus: manageEcdata.processStatus,
          leadClearanceHistory: manageEcdata.leadClearanceHistory,
          alter: manageEcdata.isAlter,
          key: index,
          cpRemarks: !isEmpty(manageEcdata.clientDetails)
            ? manageEcdata.clientDetails.profileRemarks
            : "--",
          cpStatus: !isEmpty(manageEcdata.clientDetails)
            ? manageEcdata.clientDetails.profileStatus
            : "--",
          clientType: manageEcdata.leadQuotationRange,
          onlyEngagement: manageEcdata.onlyEngagement,
          goodLookingClient:manageEcData.goodLookingClient,
          onlyEngagementStatus:manageEcData. onlyEngagementStatus,
          highEndClient:manageEcData.highEndClient
        }
      }) 
      : []

  console.log(manageEcDataTable, "manageEcDataTable")
  //download feature in data table
  // const { ExportCSVButton } = CSVExport

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
    },

    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      csvExport: false,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        console.log(row, "row")
        return (
          <div className={row.processStatus != "PS9" ? "disabled-button" : ""}>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: leadData,
                  leadClientId: leadData,
                  mode: "EC",
                  menuName: "ManageEc",
                },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "110px",
      },
    },

    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      formatter: (cellContent) => {

        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break
          case "Yellow":
            badgeStyle = { backgroundColor: "#fce303" } // Yellow color
            break
          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            badgeStyle = {}
        }


        return (
          <div style={{ textAlign: "center", justifyContent: "center" }}>
            {cellContent ? (
              <span
                className={"badge"}
                style={{
                  ...badgeStyle,
                  display: "inline-block",
                  width: "35px",        // Equal width and height for a circle
                  height: "35px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>--</span>
              // Show '--' if cellContent is empty
            )}
          </div>)

      }
    },//
    {
      dataField: "onlyEngagement",
      text: "Only Engagement",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        console.log(cellContent, row, "kk")
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#c5ff00",
                    backgroundColor: "#c5ff00"
                  }}
                /> : "--"}
              </div>
              {row.onlyEngagementStatus?`(${row.onlyEngagementStatus})`:""}
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "goodLookingClient",
      text: "Good Looking Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {   
         return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#FFD700",
                     backgroundColor: "#BF55EC"
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "highEndClient",
      text: "High End Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#BF55EC",
                      backgroundColor: "#FFD700"
                 
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),

      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        color: "#e40d8c",
        textTransform: "uppercase",
      }),

      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },

    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesAgentName",
      text: "Sales Agent Name",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "assignedEcName",
      text: "Ec Agent Name",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row justify-content-between">
            <h6 className="mt-1">
              {!isEmpty(row.assignedEcName) ? row.assignedEcName : "--"}
            </h6>
            <Button
              style={{
                background: "#17b77d",
                border: "none",
                cursor: "pointer",
                color: "white",
                padding: "5px",
                borderRadius: "3px",
                marginLeft: "12px",
              }}
              onClick={() => {
                setUnassignedModal(true)
                setUnassignedData(row)
              }}
            >
              <i className="fas fa-user-lock"></i>
            </Button>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "175px",
      },
    },

    {
      dataField: "events",
      text: "No of Events",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">{row.events}</span>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "allowOrder",
      text: "Allow Order",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div>
            <Badge
              color={row.allowOrderData === true ? "success" : "danger"}
              style={{ padding: "6px", fontSize: "12px" }}
            >
              {" "}
              {row.allowOrder}
            </Badge>
          </div>
        )
      },
      headerStyle: {
        minWidth: "130px",
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        color: "#e40d8c",
        fontWeight: 600,
      }),

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "ecAssign",
      text: "EC Assign",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <Button
            color={isEmpty(row.ecProcessStatus) ? "danger" : "success"}
            onClick={() => {
              setModal(true)
              editAssignDetails(row)
              setAssignDetails(row)
            }}
          >
            {/* {isEmpty(row.assignedEcName) ? "Assigned" : row.assignedEcName} */}
            {isEmpty(row.ecProcessStatus) ? "UnAssigned" : "Assigned"}
          </Button>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "clearanceReport",
      text: "Clearance Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row justify-content-between">
            <Button
              // className="btn btn-warning"
              onClick={() => {
                if (
                  row.leadClearanceStatusId === "PS22" ||
                  row.leadClearanceStatusId === "PS24"
                ) {
                  setClearanceModal(false)
                } else {
                  setClearanceModal(true)
                  setLeadId(row._id)
                }
              }}
              style={{
                display: "inline-block",
                // fontSize: "10px",
                border: "none",
                cursor: "pointer",
                color: "white",
                background:
                  row.leadClearanceType === "paid"
                    ? "#34c28f"
                    : row.leadClearanceType === "partialPaid" ||
                      row.leadClearanceType === "partialpaid"
                      ? "#f9851b"
                      : row.leadClearanceType === "Exception" ||
                        row.leadClearanceType === "exception"
                        ? "#F1B44C"
                        : row.leadClearanceType === "complementary" ||
                          row.leadClearanceType === "Complementary"
                          ? "#50a5f1"
                          : "#c31919ed",

                padding: "6px",
                borderRadius: "4px",
              }}
            >
              {row.leadClearanceStatusId === "PS21" ||
                row.leadClearanceStatusId === "PS23" ||
                row.leadClearanceStatusId === "PS25"
                ? row.leadClearanceName
                : row.leadClearanceStatusId === "PS22" ||
                  row.leadClearanceStatusId === "PS24"
                  ? row.leadClearanceName
                  : row.leadClearanceName}
            </Button>
            {/* )} */}
            <div
              className="mx-2 mt-2"
              onClick={() => {
                setClearanceHistoryDetails(row.leadClearanceHistory)
                setClearanceHistoryModal(true)
              }}
            >
              <i
                className="fas fa-eye"
                style={{ color: "#50a5f1", fontSize: "13px" }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "210px",
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
    },
    {
      dataField: "ecLeadStatus",
      text: "EC Status",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),

      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          >
            {row.statusName}
          </button>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  //Pagination section start //
  //Search filter
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      manageEcAction.loadManageEcList({
        searchFilter: searchInput,
        isManageEC: true,
        page: pageChange ? pageCount : 1,
        limit: 25,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchVenue = venueName && venueName ? venueName.value : ""
    var searchFromDate =
      manageEcData && manageEcData.fromDate
        ? moment(manageEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      manageEcData && manageEcData.toDate
        ? moment(manageEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      manageEcData && manageEcData.leadNo ? manageEcData.leadNo : ""

    var searchPremium = isPremium
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.isManageEC = true
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchVenue) {
      searchvalue.venueName = searchVenue
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_ec_unassigned_lead`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")

        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const leadDate = data.leadDate
              ? moment(data.leadDate)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
              : []
            const eventCount =
              !isEmpty(data) && data.events.length > 0
                ? data.events.length
                : 0

            const groomName = !isEmpty(data.groomName)
              ? JSON.stringify(data.groomName).replace(/","/g, "\n")
              : "--"
            const brideName = !isEmpty(data.brideName)
              ? JSON.stringify(data.brideName).replace(/","/g, "\n")
              : "--"
            const cpRemarks = !isEmpty(data.clientDetails)
              ? data.clientDetails.profileRemarks
              : ""
            const cpRemarksValue = !isEmpty(cpRemarks)
              ? cpRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            return {
              _id: data._id,
              sNo: index + 1,
              leadNo: data.leadNo,
              branchId: data.branchId,
              routeData: data,
              leadNoData: data.leadNo,
              branchName: data.branchName,
              isPremium: data.isPremium,
              venueName: data.venueName,
              clientName: !isEmpty(data.clientDetails)
                ? data.clientDetails.firstName +
                " " +
                data.clientDetails.lastName
                : "",
              brideName: brideName,
              groomName: groomName,
              companyId: data.companyId,
              companyName: data.companyName,
              leadServiceName: data.leadServiceName,
              leadSourceName: data.leadSourceName,
              leadType: data.leadType,
              salesUrge: data.salesUrge,
              overallStatus: !isEmpty(data.overAllStatus)
                ? data.overAllStatus
                : "--",
              paymentStatus: !isEmpty(data.paymentStatus)
                ? data.paymentStatus
                : "",
              allowOrderData: data.isAllowOrder,
              allowOrder: data.isAllowOrder === true ? "YES" : "NO",
              eventDetails: data.events,
              clientCode: !isEmpty(data.clientDetails)
                ? data.clientDetails.clientNo
                : "",
              events: eventCount,
              ecAssign: isEmpty(data.ecProcessStatus)
                ? "Unassigned"
                : "Assigned",
              assignedEcName: !isEmpty(data.leadECAssign)
                ? data.leadECAssign.assignedToName
                : "--",
              assignedEcId: !isEmpty(data.leadECAssign)
                ? data.leadECAssign.assignedTo
                : "",
              salesAgentName: !isEmpty(data.leadAssign)
                ? data.leadAssign.assignedToName
                : "--",
              leadClearanceType: !isEmpty(data.leadClearance)
                ? data.leadClearance.type
                : "--",
              leadClearanceStatusId: !isEmpty(data.ecClearanceStatus)
                ? data.ecClearanceStatus
                : "",
              leadClearanceName: !isEmpty(data.ecClearanceStatusName)
                ? data.ecClearanceStatusName
                : "--",
              leadDate: leadDate,
              ecProcessStatus: data.ecProcessStatus,
              ecProcessStatusName: data.ecProcessStatusName,
              clearanceReport:
                data.ecProcessStatus !== "PS2"
                  ? data.ecProcessStatusName
                  : "--",
              cpRemarks: cpRemarksValue,
              cpStatus: !isEmpty(data.clientDetails)
                ? data.clientDetails.profileStatus
                : "--",
              key: index,
              clientType: data.leadQuotationRange,
              onlyEngagement: data.onlyEngagement == true ? "YES" : "NO",
              goodLookingClient:data.goodLookingClient == true ? "YES" : "NO",
              highEndClient:data.highEndClient == true ? "YES" : "NO",
            }
            // }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Lead No,Client Type, Only Engagement,Good Looking Client,High End Client,Company,Branch,Client Code,Client Name,CP Status, CP Remarks,Bride Name,Groom Name, Lead Date, Ec Agent Name,No of Events,Allow Order, Overall Status,EC Assign, Clearance Report",
          ]

          let usersCsv = !isEmpty(unassignedExcelDataTable)
            ? unassignedExcelDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                assignedEcName,
                events,
                allowOrder,
                overallStatus,
                ecAssign,
                leadClearanceName,
              } = user
              acc.push([
                sNo,
                leadNo,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                assignedEcName,
                events,
                allowOrder,
                overallStatus,
                ecAssign,
                leadClearanceName,
              ])

              console.log("test", acc)
              return acc
            }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "ManageEC.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }
  //isTeamSchedule: "INPROGRESS"
  // const rowStyle = (row) => {
  //   console.log(row,"mirow")

  //   if(row.alter===true){
  //     console.log("row success")
  //     return { style: { backgroundColor: 'lightgreen' } }
  //   }
  //   return {}
  // }
  //const rowStyle = { backgroundColor: '#c8e6c9' }
  // const rowClasses = (row) => {

  //   if (row.brideName =="Shanta") {
  //     return "custom-row-style"
  //   }
  //   // Add more conditions as needed
  //   return ""
  // }
  // const rowStyle = (row) => {
  //   const style = {}
  //   if (row.alter===true) {
  //     style.backgroundColor = '#c8e6c9'
  //   }

  //   return style
  // }
  // const rowStyle = (row) => {
  //   // console.log(row, "row details")
  //   const style = {}
  //   if (row.alter===true) {
  //     style.backgroundColor = "#fd8301b3"
  //   } else {
  //     style.backgroundColor = "#ffffff"
  //   }

  //   return style
  // }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                            }}
                          >
                            Download
                          </Button>
                        </div>

                        <div
                          style={{
                            float: "right",
                            marginRight: "20px",
                            marginTop: "-30px",
                          }}
                        >
                          <div className="d-flex flex-row">
                            <div className="quote-altered-lead"></div>
                            <h6 className="alter-font">Quote Altered Lead</h6>
                          </div>
                          <div>
                            <h6 className="cp-font">CP - Client Profile</h6>
                          </div>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          // striped={true}
                          bordered={true}
                          // rowStyle={(row) => row.rowStyle}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 25,
    page: 1,
    totalSize: manageEc_details.length,
    data:
      !isEmpty(manageEc_details) && manageEc_details.length > 0
        ? manageEc_details.slice(0, 25)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(manageEc_details.data) && manageEc_details.data.length > 0
        ? manageEc_details.data
        : []

    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchVenue = venueName && venueName ? venueName.value : ""
    var searchFromDate =
      manageEcData && manageEcData.fromDate
        ? moment(manageEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      manageEcData && manageEcData.toDate
        ? moment(manageEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      manageEcData && manageEcData.leadNo ? manageEcData.leadNo : ""
    var searchPremium = isPremium
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.page = page
    searchvalue.limit = sizePerPage
    searchvalue.isManageEC = true
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }
    if (searchVenue) {
      searchvalue.venueName = searchVenue
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    specificDispatch(manageEcAction.loadManageEcList(searchvalue))

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //Handle assign details
  const handleAssignDetails = () => {
    const ecAssign = {
      leadId: assignDetails._id,
      assignedTo: salesAgentList.value,
    }
    setModal(false)
    console.log(ecAssign, "ecAssign details")
    specificDispatch(manageUnassignedAction.addEcAssignList(ecAssign))
    setTimeout(() => {
      dispatch(manageEcAction.loadManageEcList(searchValue))
    }, 2000)
  }
  console.log(unassignedData, "unassignedData")

  //Handle Unassigned Details
  const handleUnassignDetails = () => {
    const unassignedDetails = {
      leadId: unassignedData._id,
      assignedTo: !isEmpty(unassignedData.assignedEcId)
        ? unassignedData.assignedEcId
        : "",
    }

    console.log(unassignedDetails, "unassignedDetails")
    specificDispatch(manageEcAction.updateUnassignedDetails(unassignedDetails))
    setTimeout(() => {
      setUnassignedModal(false)
      dispatch(manageEcAction.loadManageEcList(searchValue))
    }, 2000)
  }

  //expand row functionality from bootstrap table

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Food
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Travel
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Premium
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Client Checklist
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Schedule
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Equipment Schedule
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")
                const eventDate = new Date(data.eventDate)
                console.log(eventDate, "eventDate")

                if (
                  new Date(data.eventDate) >= new Date(manageEcData.fromDate) &&
                  new Date(data.eventDate) <= new Date(manageEcData.toDate)
                ) {
                  console.log(data, "expandRow data")
                  const alter = data.isAlter
                  const rowStyle =
                    data.isAlter === true
                      ? { backgroundColor: "#3abd856e" }
                      : {}
                  console.log(alter, "isAlter value")
                  console.log(rowStyle, "style value")
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>
                        {moment(data.eventDate).format(dateFormate)}
                      </td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <th style={rowStyle}> {data.food}</th>
                      <th style={rowStyle}>{data.travelStay}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>
                        <Badge
                          color={data.isPremium === true ? "success" : "danger"}
                          style={{ padding: "8px 14px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.isPremium == true ? "Yes" : "No"}
                        </Badge>
                      </td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                      <td style={rowStyle}>
                        <Badge
                          color={
                            data.ischecklistSchedule === "COMPLETED"
                              ? "success"
                              : data.ischecklistSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.ischecklistSchedule}
                        </Badge>
                      </td>
                      <td style={rowStyle}>
                        {" "}
                        <Badge
                          color={
                            data.isTeamSchedule === "COMPLETED"
                              ? "success"
                              : data.isTeamSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isTeamSchedule}
                        </Badge>
                      </td>
                      <td style={rowStyle}>
                        {" "}
                        <Badge
                          color={
                            data.isEquipmentSchedule === "COMPLETED"
                              ? "success"
                              : data.isEquipmentSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isEquipmentSchedule}
                        </Badge>
                      </td>
                    </tr>
                  )
                } else if (
                  isEmpty(manageEcData.fromDate) &&
                  isEmpty(manageEcData.toDate)
                ) {
                  const alter = data.isAlter
                  const rowStyle =
                    data.isAlter === true
                      ? { backgroundColor: "#3abd856e" }
                      : {}
                  console.log(alter, "isAlter value")
                  console.log(rowStyle, "style value")
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>
                        {data.eventNo}
                      </th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>
                        {moment(data.eventDate).format(dateFormate)}
                      </td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <th style={rowStyle}>{data.food}</th>
                      <th style={rowStyle}>{data.travelStay}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>
                        <Badge
                          color={data.isPremium == true ? "success" : "danger"}
                          style={{ padding: "8px 14px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.isPremium == true ? "Yes" : "No"}
                        </Badge>
                      </td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                      <td style={rowStyle}>
                        <Badge
                          color={
                            data.ischecklistSchedule === "COMPLETED"
                              ? "success"
                              : data.ischecklistSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {" "}
                          {data.ischecklistSchedule}
                        </Badge>
                      </td>
                      <td style={rowStyle}>
                        {" "}
                        <Badge
                          color={
                            data.isTeamSchedule === "COMPLETED"
                              ? "success"
                              : data.isTeamSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isTeamSchedule}
                        </Badge>
                      </td>
                      <td style={rowStyle}>
                        {" "}
                        <Badge
                          color={
                            data.isEquipmentSchedule === "COMPLETED"
                              ? "success"
                              : data.isEquipmentSchedule === "INPROCESS"
                                ? "warning"
                                : "danger"
                          }
                          style={{ padding: "6px", fontSize: "12px" }}
                        >
                          {data.isEquipmentSchedule}
                        </Badge>
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  //get today's date
  const current = new Date()
  const date = `${current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`
  console.log(date, "today date")
  //empid
  const empId = localStorage.getItem("empId")
  console.log(empId, "my employee Id")

  const addClearance = () => {
    const applyClearance = {
      leadId: leadId,
      mode: "LEVEL1",
      type: "unpaid",
      clearanceDate: date,
      clearanceBy: empId,
      clearanceStatus: "PS21",
      remarks: "",
    }
    console.log(applyClearance, "applyClearance")
    specificDispatch(manageEcAction.addClearance(applyClearance))
    setTimeout(() => {
      dispatch(manageEcAction.loadManageEcList(searchValue))
      setClearanceModal(false)
    }, 1000)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            manageEcMetaData
                              ? manageEcMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 11, // Ensures the dropdown appears above other content
                            }),
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            manageEcMetaData
                              ? manageEcMetaData.eventOptions
                              : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Venue"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="venueName"
                          value={venueName}
                          // isMulti
                          onChange={(e) => setVenueName(e)}
                          options={
                            manageEcMetaData
                              ? manageEcMetaData.venueOptions
                              : []
                          }
                          placeholder="Select Venue"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"EC Agent"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={ecagentOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter EC Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={manageEcData.fromDate}
                          max={manageEcData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={manageEcData.toDate}
                          min={manageEcData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={manageEcData.leadNo}
                          // min={manageEcData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-4">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isPremium"
                                  value={status.value}
                                  checked={isPremium === status.value}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-4">
                        <div className="d-flex flex-row">
                          {alterList.map((data, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isAlter"
                                  value={data.value}
                                  checked={isAlter === data.value}
                                  onChange={(e) =>
                                    handleAlterChange(e, data.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {data.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={manageEcDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(manageEc_details)
                        ? manageEc_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          {clearanceModal && (
            <Modal
              show={clearanceModal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body>Do You Want To Clearance The Report?</Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                      addClearance()
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
      </div>
      {/* Clearance history modal */}
      {clearanceHistoryModal && (
        <Modal
          show={clearanceHistoryModal}
          onHide={handleClearanceHistory}
          size="lg"
          backdrop="static"
        >
          <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
            <h5 style={{ color: "white" }}>Clearance Status History</h5>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered striped responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Clearance Date</th>
                      <th>Payment Status</th>
                      <th>Level</th>
                      <th>Payment %</th>
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Status</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clearanceHistoryDetails &&
                      clearanceHistoryDetails.length > 0 ? (
                      clearanceHistoryDetails.map((data, index) => {
                        const attachment = !isEmpty(data.attachment)
                          ? data.attachment
                          : ""
                        const clearanceDate = !isEmpty(data.clearanceDate)
                          ? moment(data.clearanceDate)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(dateFormate)
                          : []
                        const createdAt = !isEmpty(data.CreatedOn)
                          ? moment(data.CreatedOn)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormate} hh:mm A`)
                          : []
                        const processStatusName =
                          !isEmpty(manageEcMetaData) &&
                            !isEmpty(manageEcMetaData.processStatusOptions) &&
                            manageEcMetaData.processStatusOptions &&
                            manageEcMetaData.processStatusOptions.length > 0
                            ? manageEcMetaData.processStatusOptions.find(
                              (_) => _.processStatusId == data.clearanceStatus
                            )
                            : "--"
                        return (
                          <>
                            <tr key={data._id}>
                              <td>{index + 1}</td>
                              <td>{clearanceDate}</td>
                              <td>{data.paymentType}</td>
                              <td>{data.mode}</td>
                              <td>{data.paymentReceivedPercentage}</td>

                              <td>{data.remarks}</td>
                              <td>
                                {" "}
                                <a
                                  onClick={() =>
                                    window.open(attachment, "_blank")
                                  }
                                >
                                  <span
                                    style={{
                                      color: "#e40d8c",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    View
                                  </span>
                                </a>
                              </td>
                              <td>
                                <button
                                  style={{
                                    background:
                                      data.paymentType == "paid"
                                        ? "#34c28f"
                                        : data.paymentType == "partialpaid" ||
                                          data.paymentType == "partialPaid"
                                          ? "#f9851b"
                                          : data.paymentType === "Exception" ||
                                            data.paymentType === "exception"
                                            ? "#F1B44C"
                                            : data.paymentType ===
                                              "complementary" ||
                                              data.paymentType === "Complementary"
                                              ? "#50a5f1"
                                              : "#c31919ed",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "4px 6px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {processStatusName.label}
                                </button>
                              </td>
                              <td>{data.insertedByName}</td>
                              <td>{createdAt}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={10} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={handleClearanceHistory}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {unassignedModal && (
        <Modal show={unassignedModal} onHide={handleUnassignedModal} size="md">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              minHeight: "65px",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <div className="d-flex flex-row">
              <span>Confirm</span>
            </div>
          </Modal.Header>
          <Modal.Body>Are you sure , You want to Unassigned the EC?</Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                // type="submit"
                onClick={() => {
                  setUnassignedModal()
                }}
                className="btn btn-danger buttons"
              >
                {" "}
                Cancel
              </Button>
              <Button
                // type="submit"
                onClick={() => handleUnassignDetails()}
                style={{ marginLeft: "10px" }}
                className="btn btn-success buttons"
              >
                {" "}
                Confirm
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <div className="d-flex justify-content-center mb-5">
        {modal && (
          <Modal size="xl" show={modal} onHide={toggle}>
            <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
              <h5
                style={{
                  color: "#ffffff",
                  fontWeight: 800,
                  textTransform: "uppercase",
                }}
              >
                Lead No: <span style={{ fontWeight: 600 }}>{leadNo}</span>
              </h5>
            </Modal.Header>

            <Modal.Body>
              <Row className="d-flex flex-row">
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"}>{"Company"}</Label>
                  </div>
                  <Select
                    type="text"
                    name="companyDetails"
                    value={companyDetails}
                    onChange={(e) => setCompanyDetails(e)}
                    options={
                      manageEcMetaData ? manageEcMetaData.companyOptions : []
                    }
                    placeholder="Select Company"
                    classNamePrefix="select2-selection"
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"}>{"Branch"}</Label>
                  </div>
                  <Select
                    type="text"
                    name="branchDetails"
                    value={branchDetails}
                    onChange={(e) => setBranchDetails(e)}
                    options={
                      manageEcMetaData ? manageEcMetaData.branchOptions : []
                    }
                    placeholder="Select Branch"
                    classNamePrefix="select2-selection"
                  />
                </Col>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"}>{"EC Agent"}</Label>
                  </div>
                  <ReactSearchAutocomplete
                    name="salesAgentList"
                    items={agentOptions}
                    value={salesAgentList}
                    type="autoComplete"
                    resultStringKeyName="label"
                    showIcon={false}
                    onSelect={(e) => setSalesAgentList(e)}
                    onChange={(e) => setSalesAgentList(e.target.value)}
                    placeholder="Enter EC Agent"
                    fuseOptions={fuseOptions} // Search on both fields
                    styling={{
                      height: "34px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      backgroundColor: "white",
                      boxShadow: "none",
                      hoverBackgroundColor: "#E40D8C",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Courier",
                      iconColor: "green",
                      clearIconMargin: "3px 8px 0 0",
                      zIndex: 100,
                    }}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleAssignDetails()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6.7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  )
}

ManageEc.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageEc)
)
